var map = {
	"./$GMUSIC-icon.png": 1164,
	"./BAT-icon.png": 1165,
	"./BTC-icon.png": 1166,
	"./BXC-icon.png": 1167,
	"./CC-icon.png": 560,
	"./DistTest-icon.png": 1753,
	"./ETH-icon.png": 1168,
	"./GALA-icon.png": 735,
	"./GALA[ETH]-icon.png": 1754,
	"./GALA[GYRI]-icon.png": 1755,
	"./MTRM-icon.png": 1756,
	"./NODETESTCOIN-icon.png": 1757,
	"./NODETESTCOIN-transparent-icon.png": 1758,
	"./SILK-icon.png": 923,
	"./SILK[GYRI]-icon.png": 1759,
	"./TANK-icon.png": 1169,
	"./TCTESTCOIN-icon.png": 1760,
	"./TEST-icon.png": 1761,
	"./TOWN-icon.png": 1170,
	"./USD-icon.png": 837,
	"./mastercard-icon.png": 558,
	"./simplex-icon.png": 1171,
	"./visa-icon.png": 559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 730;